// extracted by mini-css-extract-plugin
export default {"verticalCenter":"SnackBar__verticalCenter___DORrk"};